<template>
  <div class="services-page">
    <div class="row services-row">
      <div class="col-12 col-xl-6 col-lg-5">
        <figure class="image-wrapper">
          <img
            src="~/assets/services/services-1.jpeg"
            alt="Mark Pieszak at JsPoland, Warsaw 2019"
          />
          <figcaption class="text-left">
            <a href="https://twitter.com/MarkPieszak" target="_blank"
              >@markpieszak</a
            >
            at JsPoland, Warsaw 2019
          </figcaption>
        </figure>
      </div>
      <div class="col-12 col-xl-6 col-lg-7 text-left card-container">
        <div class="card-wrapper card-wrapper--right">
          <h3 class="trilon-pink">Helping Teams Be Successful</h3>
          <h2>Consulting</h2>
          <p>
            Our goal is to share our expertise and domain-knowledge with your
            team, tackling tough issues right by your side, collaborating with
            your team on many levels such as:
            <br />
          </p>
          <ul>
            <li>
              <span>
                <i class="fas fa-check"></i> </span
              >Providing technical guidance & architectural reviews
            </li>
            <li>
              <span>
                <i class="fas fa-check"></i> </span
              >Advising best practices
            </li>
            <li>
              <span>
                <i class="fas fa-check"></i> </span
              >Solving design decisions
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row services-row">
      <div class="col-12 col-xl-6 col-lg-5 d-lg-none">
        <figure class="image-wrapper">
          <img
            src="~/assets/services/services-3.jpeg"
            alt="Kamil Mysliwiec at JsPoland, Warsaw 2019"
          />
          <figcaption class="text-right">
            <a href="https://twitter.com/kammysliwiec" target="_blank"
              >@kammysliwiec</a
            >
            at JsPoland, Warsaw 2019
          </figcaption>
        </figure>
      </div>
      <div class="col-12 col-xl-6 col-lg-7 text-left card-container">
        <div class="card-wrapper card-wrapper--left">
          <h3 class="trilon-pink">Build & Scale Faster</h3>
          <h2>Team Augmentation</h2>
          <p>
            With team augmentation, Trilon members become an extension of your
            team. Working directly with you on a daily basis to help take your
            project to the next-level. We aim to:
            <br />
          </p>
          <ul>
            <li>
              <span>
                <i class="fas fa-check"></i> </span
              >Mentor team members
            </li>
            <li>
              <span>
                <i class="fas fa-check"></i> </span
              >Address security & performance concerns
            </li>
            <li>
              <span>
                <i class="fas fa-check"></i> </span
              >Perform in-depth code reviews
            </li>
            <li>
              <span>
                <i class="fas fa-check"></i> </span
              >Assist in Engineering & Development
            </li>
          </ul>
        </div>
      </div>
      <div class="col-12 col-xl-6 col-lg-5 d-none d-lg-block">
        <figure class="image-wrapper">
          <img
            src="~/assets/services/services-3.jpeg"
            alt="Kamil Mysliwiec at JsPoland, Warsaw 2019"
          />
          <figcaption class="text-right">
            <a href="https://twitter.com/kammysliwiec" target="_blank"
              >@kammysliwiec</a
            >
            at JsPoland, Warsaw 2019
          </figcaption>
        </figure>
      </div>
    </div>
    <div class="row services-row">
      <div class="col-12 col-xl-6 col-lg-5">
        <figure class="image-wrapper">
          <img
            src="~/assets/services/services-6.jpg"
            alt="Kamil Mysliwiec at JsCamp, Barcelona 2019"
          />
          <figcaption class="text-left">
            <a href="https://twitter.com/kammysliwiec" target="_blank"
              >@kammysliwiec</a
            >
            at JsCamp, Barcelona 2019
          </figcaption>
        </figure>
      </div>
      <div class="col-12 col-xl-6 col-lg-7 text-left card-container">
        <div class="card-wrapper card-wrapper--right">
          <h3 class="trilon-pink">Learn, Evolve, Grow</h3>
          <h2>Corporate Workshops & Trainings</h2>
          <p>
            Get your team up to speed with our experts in modern technologies.
            Our goal is to change the way we approach knowledge, learning, and
            education through hands-on training tailored to your needs.
            <!-- <ul>
              <li>Angular</li>
              <li>TypeScript</li>
              <li>RxJs</li>
              <li>Node.js | NestJS</li>
            </ul>-->
          </p>
        </div>
      </div>
    </div>
    <div class="row services-row">
      <div class="col-12 d-lg-none">
        <figure class="image-wrapper">
          <img
            src="~/assets/services/services-5.jpg"
            alt="Mark Pieszak at JsPoland, Warsaw 2019"
          />
          <figcaption class="text-right">
            <a href="https://twitter.com/MarkPieszak" target="_blank"
              >@markpieszak</a
            >
            at JsPoland, Warsaw 2019
          </figcaption>
        </figure>
      </div>
      <div class="col-12 col-xl-6 col-lg-7 text-left card-container">
        <div class="card-wrapper card-wrapper--left">
          <h3 class="trilon-pink">Setting up for Success</h3>
          <h2>Architectural Planning</h2>
          <p>
            Let's plan the next phases of your application, setting up the
            groundwork for growth, scale, and future success.
            <br />
            <br />With Google Developer Experts, core-team members from
            different organizations, key open-source maintainers & contributors,
            renown community experts, you can be confident that your project is
            in good hands.
          </p>
        </div>
      </div>
      <div class="col-12 col-xl-6 col-lg-5 d-none d-lg-block">
        <figure class="image-wrapper">
          <img
            src="~/assets/services/services-5.jpg"
            alt="Mark Pieszak at JsPoland, Warsaw 2019"
          />
          <figcaption class="text-right">
            <a href="https://twitter.com/MarkPieszak" target="_blank"
              >@markpieszak</a
            >
            at JsPoland, Warsaw 2019
          </figcaption>
        </figure>
      </div>
    </div>
  </div>
</template>

<script setup>

definePageMeta({
  layout: 'pages',
  pageKey: 'services',
  pageTitle: 'Our Services',
  subTitle: 'Check our Services',
  hideWhatWeDo: true
});
if (typeof document !== 'undefined') {
  document.addEventListener('DOMContentLoaded', (ev) => {
    const hash = window.location.hash;
    if (hash) {
      setTimeout(() => {
        this.$scrollTo(hash, 500, { offset: -25 });
      }, 200);
    }
  });
}
const structuredData = ref({
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'Organization',
          '@id': 'https://trilon.io/#organization',
          name: 'Trilon',
          url: 'https://trilon.io/',
          sameAs: [],
          logo: {
            '@type': 'ImageObject',
            '@id': 'https://trilon.io/#logo',
            url: 'https://trilon.io/trilon-logo-clear.png',
            caption: 'Trilon',
          },
          image: {
            '@id': 'https://trilon.io/#logo',
          },
        },
        {
          '@type': 'WebSite',
          '@id': 'https://trilon.io/#website',
          url: 'https://trilon.io/',
          name: 'Trilon',
          publisher: {
            '@id': 'https://trilon.io/#organization',
          },
          potentialAction: {
            '@type': 'SearchAction',
            target: 'https://trilon.io/?search={search_term_string}',
            'query-input': 'required name=search_term_string',
          },
        },
        {
          '@type': 'WebPage',
          '@id': 'https://trilon.io/blog#webpage',
          url: 'https://trilon.io/blog',
          inLanguage: 'en-US',
          name: 'Next-level consulting from NestJS and Angular Universal core team members.',
          isPartOf: {
            '@id': 'https://trilon.io/#website',
          },
          about: {
            '@id': 'https://trilon.io/#organization',
          },
          image: {
            '@type': 'ImageObject',
            '@id': 'https://trilon.io/#primaryimage',
            url: 'https://trilon.io/meta/og-image.png',
            caption: 'Trilon',
          },
          primaryImageOfPage: {
            '@id': 'https://trilon.io/#primaryimage',
          },
          datePublished: '2019-02-24T10:30:12+00:00',
          dateModified: '2019-07-17T11:28:59.031Z',
          description:
            'Next-level consulting from NestJS and Angular Universal core team members. We give teams the push they need to truly succeed in today&#x27;s ever-changing world.',
        },
      ],
});
const activeId = ref(0);
const isOpenedMobile = ref(false);
useHead({
  
      title: 'Trilon Services',
      meta: [
        // hid is used as unique identifier. Do not use `vmid` for it as it will not work
        {
          vmid: 'description',
          name: 'description',
          content:
            "Next-level consulting, team augmentation, and training from NestJS and Angular Universal core team members. We give teams the push they need to truly succeed in today's ever-changing world.",
        },
      ],
      __dangerouslyDisableSanitizers: ['script'],
      script: [
        {
          innerHTML: JSON.stringify(structuredData),
          type: 'application/ld+json',
        },
      ],
})
</script>

<style lang="scss" scoped>
.services-page {
  padding-top: 8rem;

  @media (max-width: 1200px) {
    padding-top: 8rem;
  }

  @media (max-width: 600px) {
    padding-top: 10rem;
  }

  .card-wrapper {
    padding: 7rem 5rem;
    background: #080e1e;
    z-index: 1;
    position: relative;

    h2 {
      margin: 0.8rem 0 2rem;
    }
    h3 {
      font-size: 1.1rem;
    }
    p {
      line-height: 1.8rem;
    }

    @media (max-width: 1200px) {
      padding: 4rem 3rem;

      h2 {
        font-size: 1.6rem;
      }
      p {
        font-size: 0.9rem;
      }
    }

    ul {
      padding: 0;
      margin: 0;
    }
    li {
      line-height: 3rem;
      display: block;
    }

    ul span {
      background: rgba(197, 12, 79, 0.3);
      color: #e31d61;
      border-radius: 50%;
      width: 25px;
      height: 25px;
      display: inline-block;
      position: relative;
      font-size: 12px;
      vertical-align: middle;
      margin-right: 15px;
    }

    li span i {
      position: absolute;
      top: 54%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
    }

    @media (max-width: 576px) {
      padding: 3rem 2rem;

      p,
      li {
        font-size: 0.9rem;
      }
      li {
        line-height: 2rem;
        margin-bottom: 1rem;
        &:last-of-type {
          margin-bottom: 0;
        }
      }
    }
  }
  .card-wrapper--right {
    transform: translateX(-5rem);
  }
  .card-wrapper--left {
    transform: translateX(5rem);
  }
  @media (max-width: 992px) {
    .card-wrapper--right,
    .card-wrapper--left {
      transform: translateX(0);
    }
  }

  figcaption {
    margin: 1.2rem 0 0;
    font-size: 0.85rem;
    color: #fff;

    @media (max-width: 1200px) {
      display: none;
    }
  }

  .card-container {
    @media (max-width: 992px) {
      padding: 3rem;
    }
    @media (max-width: 768px) {
      padding: 1.5rem;
    }
    @media (max-width: 576px) {
      padding: 1rem;
    }
  }
}
.services-row {
  padding-top: 2rem;
  padding-bottom: 15rem;

  @media (max-width: 992px) {
    padding-bottom: 14rem;
  }
  .image-wrapper {
    position: absolute;
    z-index: 0;

    @media (max-width: 992px) {
      left: 0;
      right: 0;
      height: 350px;
      overflow: hidden;

      img {
        top: 30%;
        left: 50%;
        transform: translate(-50%, -50%);
        position: absolute;
      }
    }
    @media (max-width: 576px) {
      height: 600px;

      img {
        max-width: 150%;
      }
    }
  }
  &:nth-of-type(even) {
    .image-wrapper {
      transform: translate(-5rem, -6rem) scale(1.1);
    }
    @media (max-width: 992px) {
      .image-wrapper {
        transform: translate(0, -9rem) scale(1);
      }
    }
  }
  &:nth-of-type(odd) {
    .image-wrapper {
      transform: translate(5rem, -6rem) scale(1.1);
    }
    @media (max-width: 992px) {
      .image-wrapper {
        transform: translate(0, -9rem) scale(1);
      }
    }
  }
  &:last-of-type {
    padding-bottom: 8rem;
    @media (max-width: 992px) {
      padding-bottom: 4rem;
    }
  }
}
</style>
